export default __webpack_public_path__ + "static/media/mobile-upload-btn-active.3ce8d0c6.png";